/**
 * AudioWatt live chat widget.
 * Floating bubble -> chat panel. Messages go to the AudioWatt back office
 * (window.ADWChatConfig.api) where staff reply from the AW Chat app.
 * Visitor identity is a random token kept in localStorage.
 */
(function () {
  'use strict';
  var cfg = window.ADWChatConfig || {};
  var API = cfg.api || 'https://audiowattstore.com/adwchat/api/visitor.php';
  var LS = window.localStorage;

  function lsGet(k) { try { return LS.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { LS.setItem(k, v); } catch (e) {} }

  var token = lsGet('adwchat_token');
  if (!token) {
    token = 'v-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    lsSet('adwchat_token', token);
  }

  var lastId = parseInt(lsGet('adwchat_lastid') || '0', 10);
  var hasChat = lsGet('adwchat_started') === '1';
  var open = false;
  var pollTimer = null;
  var unread = 0;

  /* ---------- styles ---------- */
  var css = [
    '#adw-chat-btn{position:fixed;bottom:48px;left:20px;z-index:2147483000;width:58px;height:58px;border-radius:50%;border:none;cursor:pointer;background:var(--color-primary,#1E5EFF);color:#fff;box-shadow:0 6px 24px rgba(16,37,77,.35);display:flex;align-items:center;justify-content:center;transition:transform .15s ease,bottom .25s ease}',
    'body.has-sticky-atc #adw-chat-btn{bottom:calc(92px + max(20px, env(safe-area-inset-bottom)))}',
    'body.has-sticky-atc #adw-chat-panel{bottom:calc(164px + max(20px, env(safe-area-inset-bottom)))}',
    '#adw-chat-btn:hover{transform:scale(1.06)}',
    '#adw-chat-btn:focus-visible{outline:3px solid #10254D;outline-offset:2px}',
    '#adw-chat-btn svg{width:28px;height:28px}',
    '#adw-chat-badge{position:absolute;top:-4px;right:-4px;background:#C81E1E;color:#fff;font:700 11px/20px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;min-width:20px;height:20px;border-radius:10px;padding:0 5px;display:none}',
    '#adw-chat-panel{position:fixed;bottom:120px;left:20px;z-index:2147483001;width:370px;max-width:calc(100vw - 24px);height:540px;max-height:calc(100dvh - 120px);background:#fff;border-radius:16px;box-shadow:0 12px 48px rgba(16,37,77,.28);display:none;flex-direction:column;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}',
    '#adw-chat-panel.open{display:flex}',
    '@media(max-width:480px){#adw-chat-panel,body.has-sticky-atc #adw-chat-panel{bottom:0;left:0;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;border-radius:0}}',
    '.adwc-head{background:var(--color-navy,#10254D);color:#fff;padding:16px;display:flex;align-items:center;gap:12px;flex-shrink:0}',
    '.adwc-head .adwc-dot{width:10px;height:10px;border-radius:50%;background:#2ECC71;flex-shrink:0}',
    '.adwc-head b{font-size:15px;display:block}',
    '.adwc-head small{font-size:12px;opacity:.8}',
    '.adwc-head-txt{flex:1}',
    '.adwc-x{background:none;border:none;color:#fff;font-size:22px;cursor:pointer;padding:4px 8px;line-height:1}',
    '.adwc-x:focus-visible{outline:2px solid #fff;outline-offset:2px}',
    '.adwc-new{background:rgba(255,255,255,.12);border:none;color:#fff;font-size:12px;font-weight:600;cursor:pointer;padding:6px 10px;border-radius:8px;line-height:1;white-space:nowrap}',
    '.adwc-new:hover{background:rgba(255,255,255,.22)}',
    '.adwc-new:focus-visible{outline:2px solid #fff;outline-offset:2px}',
    '.adwc-confirm{align-self:center;text-align:center;background:#fff;border:1px solid #E7EAF0;border-radius:12px;padding:12px 14px;font-size:13px;color:#333;max-width:88%}',
    '.adwc-confirm .adwc-cbtns{display:flex;gap:8px;justify-content:center;margin-top:10px}',
    '.adwc-confirm button{border-radius:8px;padding:7px 12px;font-size:12.5px;font-weight:600;cursor:pointer;border:1px solid #D5DAE3;background:#fff;color:#333}',
    '.adwc-confirm button.adwc-yes{background:var(--color-primary,#1E5EFF);border-color:transparent;color:#fff}',
    '.adwc-msgs{flex:1;overflow-y:auto;padding:16px 12px;display:flex;flex-direction:column;gap:8px;background:#F7F8FA}',
    '.adwc-m{max-width:82%;padding:10px 14px;border-radius:14px;font-size:14px;line-height:1.45;word-wrap:break-word;white-space:pre-wrap;color:#111}',
    '.adwc-m.v{align-self:flex-end;background:var(--color-primary,#1E5EFF);color:#fff;border-bottom-right-radius:4px}',
    '.adwc-m.a{align-self:flex-start;background:#fff;border:1px solid #E7EAF0;border-bottom-left-radius:4px}',
    '.adwc-m .adwc-t{display:block;font-size:10px;opacity:.65;margin-top:4px}',
    '.adwc-note{align-self:center;text-align:center;font-size:12px;color:#666;padding:4px 12px}',
    '.adwc-form{padding:16px;display:flex;flex-direction:column;gap:10px;overflow-y:auto}',
    '.adwc-form p{font-size:13.5px;color:#333;line-height:1.5;margin:0}',
    '.adwc-form label{font-size:12px;font-weight:600;color:#333}',
    '.adwc-form input{width:100%;border:1px solid #D5DAE3;border-radius:9px;padding:10px 12px;font-size:14px;font-family:inherit}',
    '.adwc-form input:focus{outline:2px solid var(--color-primary,#1E5EFF);border-color:transparent}',
    '.adwc-input{display:flex;gap:8px;padding:10px 12px;border-top:1px solid #E7EAF0;background:#fff;flex-shrink:0}',
    '.adwc-input textarea{flex:1;border:1px solid #D5DAE3;border-radius:18px;padding:10px 14px;font-size:14px;font-family:inherit;resize:none;max-height:96px;background:#F7F8FA}',
    '.adwc-input textarea:focus{outline:2px solid var(--color-primary,#1E5EFF);border-color:transparent}',
    '.adwc-send{background:var(--color-primary,#1E5EFF);color:#fff;border:none;border-radius:50%;width:40px;height:40px;cursor:pointer;flex-shrink:0;align-self:flex-end;display:flex;align-items:center;justify-content:center}',
    '.adwc-send:disabled{opacity:.5}',
    '.adwc-send:focus-visible{outline:3px solid #10254D;outline-offset:2px}',
    '.adwc-send svg{width:18px;height:18px}',
    '#adw-chat-promo{position:fixed;bottom:118px;left:20px;z-index:2147483000;max-width:250px;background:#fff;border:1px solid #E7EAF0;border-radius:14px;box-shadow:0 10px 32px rgba(16,37,77,.22);padding:12px 14px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;animation:adwc-pop .3s ease}',
    'body.has-sticky-atc #adw-chat-promo{bottom:calc(162px + max(20px, env(safe-area-inset-bottom)))}',
    '#adw-chat-promo::after{content:"";position:absolute;bottom:-8px;left:22px;width:14px;height:14px;background:#fff;border-right:1px solid #E7EAF0;border-bottom:1px solid #E7EAF0;transform:rotate(45deg)}',
    '#adw-chat-promo a{display:block;text-decoration:none;color:#111;padding-right:12px}',
    '#adw-chat-promo b{display:block;font-size:14px;margin-bottom:2px;color:var(--color-primary,#1E5EFF)}',
    '#adw-chat-promo span{font-size:12.5px;line-height:1.45;color:#444;display:block}',
    '.adwc-promo-x{position:absolute;top:2px;right:2px;width:34px;height:34px;display:flex;align-items:center;justify-content:center;background:none;border:none;border-radius:50%;color:#777;font-size:24px;line-height:1;cursor:pointer;padding:0}',
    '.adwc-promo-x:hover{background:#F1F3F7;color:#111}',
    '.adwc-promo-x:hover{color:#333}',
    '.adwc-promo-x:focus-visible{outline:2px solid var(--color-primary,#1E5EFF);outline-offset:2px}',
    '@keyframes adwc-pop{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '@media(prefers-reduced-motion:reduce){#adw-chat-promo{animation:none}}'
  ].join('\n');

  /* ---------- account promo bubble ---------- */
  var promoEl = null;
  function showPromo() {
    if (open || promoEl) return;
    promoEl = el('div', { id: 'adw-chat-promo', role: 'note', 'aria-label': 'New customer offer' },
      '<button class="adwc-promo-x" type="button" aria-label="Dismiss offer">&times;</button>' +
      '<a href="/pages/welcome-offer"><b>Save 10% on your first order</b>' +
      '<span>Create a free account and get a one-time 10% welcome discount.</span></a>');
    document.body.appendChild(promoEl);
    // × only hides for this page view — the bubble returns on the next load.
    // The only permanent off-switch is being logged in (account created).
    promoEl.querySelector('.adwc-promo-x').addEventListener('click', hidePromo);
  }
  function hidePromo() { if (promoEl) { promoEl.remove(); promoEl = null; } }

  /* ---------- DOM ---------- */
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  var sendIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M3 11.5 21 3l-8.5 18-2.3-7.2L3 11.5Z" fill="currentColor"/></svg>';
  var chatIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H9.6L5.7 19.7A1 1 0 0 1 4 18.9V5.5Z" fill="currentColor"/><circle cx="9" cy="9.5" r="1.2" fill="#10254D"/><circle cx="12" cy="9.5" r="1.2" fill="#10254D"/><circle cx="15" cy="9.5" r="1.2" fill="#10254D"/></svg>';

  function boot() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var btn = el('button', { id: 'adw-chat-btn', type: 'button', 'aria-label': 'Open chat with AudioWatt support', 'aria-expanded': 'false' }, chatIcon + '<span id="adw-chat-badge" aria-hidden="true"></span>');
    var panel = el('div', { id: 'adw-chat-panel', role: 'dialog', 'aria-label': 'AudioWatt support chat', 'aria-modal': 'false' });
    panel.innerHTML =
      '<div class="adwc-head">' +
        '<span class="adwc-dot" aria-hidden="true"></span>' +
        '<div class="adwc-head-txt"><b>AudioWatt Support</b><small>We usually reply within minutes</small></div>' +
        '<button class="adwc-new" type="button" aria-label="Start a new chat" style="display:none">+ New chat</button>' +
        '<button class="adwc-x" type="button" aria-label="Close chat">&times;</button>' +
      '</div>' +
      '<div class="adwc-body" style="display:flex;flex-direction:column;flex:1;min-height:0"></div>';
    document.body.appendChild(btn);
    document.body.appendChild(panel);

    btn.addEventListener('click', function () { toggle(btn, panel); });
    panel.querySelector('.adwc-x').addEventListener('click', function () { toggle(btn, panel); });
    panel.querySelector('.adwc-new').addEventListener('click', askNewChat);
    updateNewChatBtn();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) toggle(btn, panel); });

    if (hasChat) schedulePoll(20000); // background unread check for returning visitors

    // ?adwchat=open — the "Continue the chat" button in our reply emails lands
    // here, so open the panel instead of leaving them to find the bubble.
    if (/[?&]adwchat=open(&|$)/.test(location.search)) {
      toggle(btn, panel);
      if (window.history && history.replaceState) {
        var q = location.search.replace(/([?&])adwchat=open(&|$)/, '$1').replace(/[?&]$/, '');
        history.replaceState(null, '', location.pathname + (q === '?' ? '' : q) + location.hash);
      }
      return; // no promo bubble over an open panel
    }

    if (!cfg.loggedIn) {
      window.setTimeout(showPromo, 3000);
    }
  }

  function toggle(btn, panel) {
    open = !open;
    if (open) hidePromo(); // bubble makes way for the panel (not marked dismissed)
    panel.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', String(open));
    btn.setAttribute('aria-label', open ? 'Close chat with AudioWatt support' : 'Open chat with AudioWatt support');
    if (open) {
      unread = 0; updateBadge();
      renderBody();
      schedulePoll(4000);
      poll();
    } else {
      schedulePoll(hasChat ? 20000 : 0);
    }
  }

  function body() { return document.querySelector('#adw-chat-panel .adwc-body'); }

  function updateNewChatBtn() {
    var b = document.querySelector('#adw-chat-panel .adwc-new');
    if (b) b.style.display = hasChat ? '' : 'none';
  }

  function askNewChat() {
    var box = body().querySelector('.adwc-msgs');
    if (!box || box.querySelector('.adwc-confirm')) return;
    var c = el('div', { 'class': 'adwc-confirm' },
      'Start a new chat? This conversation will be closed.' +
      '<div class="adwc-cbtns">' +
        '<button type="button" class="adwc-yes">Start new chat</button>' +
        '<button type="button" class="adwc-no">Keep chatting</button>' +
      '</div>');
    box.appendChild(c);
    box.scrollTop = box.scrollHeight;
    c.querySelector('.adwc-no').addEventListener('click', function () { c.remove(); });
    c.querySelector('.adwc-yes').addEventListener('click', function () {
      fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' },
                   body: JSON.stringify({ action: 'close', token: token }) })
        .catch(function () {})
        .finally(function () {
          hasChat = false;
          lastId = 0;
          lsSet('adwchat_started', '0');
          lsSet('adwchat_lastid', '0');
          renderBody();
          updateNewChatBtn();
        });
    });
  }

  function renderBody() {
    updateNewChatBtn();
    var b = body();
    if (!hasChat) {
      b.innerHTML =
        '<div class="adwc-form">' +
          '<p>Hi! 👋 Questions about a product, an order, or shipping? Send us a message and we’ll get right back to you.</p>' +
          '<label for="adwc-name">Name (optional)</label>' +
          '<input id="adwc-name" type="text" autocomplete="name" maxlength="100">' +
          '<label for="adwc-email">Email (optional, so we can follow up)</label>' +
          '<input id="adwc-email" type="email" autocomplete="email" maxlength="190">' +
        '</div>' + composerHTML();
      var n = lsGet('adwchat_name'), em = lsGet('adwchat_email');
      if (n) document.getElementById('adwc-name').value = n;
      if (em) document.getElementById('adwc-email').value = em;
    } else {
      b.innerHTML = '<div class="adwc-msgs" role="log" aria-live="polite" aria-label="Chat messages"></div>' + composerHTML();
      lastId = 0; // re-fetch whole thread on open
    }
    wireComposer();
  }

  function composerHTML() {
    return '<div class="adwc-input">' +
      '<textarea rows="1" placeholder="Type your message…" aria-label="Type your message" maxlength="1000"></textarea>' +
      '<button class="adwc-send" type="button" aria-label="Send message">' + sendIcon + '</button>' +
    '</div>';
  }

  function wireComposer() {
    var ta = body().querySelector('textarea');
    var send = body().querySelector('.adwc-send');
    ta.addEventListener('input', function () { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 96) + 'px'; });
    ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); doSend(); } });
    send.addEventListener('click', doSend);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function fmtTime(iso) {
    try { return new Date(iso.replace(' ', 'T')).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch (e) { return ''; }
  }

  function appendMsg(m) {
    var box = body().querySelector('.adwc-msgs');
    if (!box) return;
    var e = el('div', { 'class': 'adwc-m ' + (m.sender === 'visitor' ? 'v' : 'a') });
    e.innerHTML = esc(m.body) + '<span class="adwc-t">' + (m.sender === 'agent' ? 'AudioWatt · ' : '') + fmtTime(m.created_at) + '</span>';
    box.appendChild(e);
    box.scrollTop = box.scrollHeight;
  }

  function doSend() {
    var b = body();
    var ta = b.querySelector('textarea');
    var send = b.querySelector('.adwc-send');
    var text = ta.value.trim();
    if (!text) return;
    var payload = { action: 'send', token: token, body: text, page: location.pathname };
    var nameInput = document.getElementById('adwc-name');
    var emailInput = document.getElementById('adwc-email');
    if (nameInput) { payload.name = nameInput.value.trim(); lsSet('adwchat_name', payload.name); }
    if (emailInput) { payload.email = emailInput.value.trim(); lsSet('adwchat_email', payload.email); }
    send.disabled = true;
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        send.disabled = false;
        if (!d.success) { alert(d.error || 'Could not send, please try again.'); return; }
        if (!hasChat) {
          hasChat = true;
          lsSet('adwchat_started', '1');
          renderBody();
        }
        ta = body().querySelector('textarea');
        if (ta) { ta.value = ''; ta.style.height = 'auto'; ta.focus(); }
        poll();
      })
      .catch(function () { send.disabled = false; alert('Network error, please try again.'); });
  }

  function schedulePoll(ms) {
    clearInterval(pollTimer);
    pollTimer = null;
    if (ms) pollTimer = setInterval(poll, ms);
  }

  function poll() {
    if (!hasChat) return;
    fetch(API + '?action=poll&token=' + encodeURIComponent(token) + '&after=' + lastId)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.success || !d.messages) return;
        d.messages.forEach(function (m) {
          lastId = Math.max(lastId, parseInt(m.id, 10));
          if (open) appendMsg(m);
          else if (m.sender === 'agent') { unread++; }
        });
        if (d.messages.length) lsSet('adwchat_lastid', String(lastId));
        updateBadge();
        if (open && d.status === 'closed') {
          var box = body().querySelector('.adwc-msgs');
          if (box && !box.querySelector('.adwc-closed')) {
            var note = el('div', { 'class': 'adwc-note adwc-closed' }, 'This chat has ended. Send a message to start a new one.');
            box.appendChild(note);
          }
        }
      })
      .catch(function () {});
  }

  function updateBadge() {
    var badge = document.getElementById('adw-chat-badge');
    if (!badge) return;
    badge.style.display = unread > 0 ? 'block' : 'none';
    badge.textContent = unread > 9 ? '9+' : String(unread);
    var btn = document.getElementById('adw-chat-btn');
    if (btn && unread > 0) btn.setAttribute('aria-label', 'Open chat with AudioWatt support, ' + unread + ' unread message' + (unread > 1 ? 's' : ''));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
